import { http, onSuccess, onFail } from "./http";

export const updateEventModuleAuth = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/auth`, data)
        .then(onSuccess, onFail);

export const addEventModuleAuthField = (eventKey, fieldId, data) =>
    http.post(`/api/cp/event/${eventKey}/module/auth/field/${fieldId}`, data)
        .then(onSuccess, onFail);

export const updateEventModuleAuthFields = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/auth/fields`, data)
        .then(onSuccess, onFail);

export const removeEventModuleAuthField = (eventKey, fieldId) =>
    http.delete(`/api/cp/event/${eventKey}/module/auth/field/${fieldId}`)
        .then(onSuccess, onFail);

export const getEventModuleAuthExtarnal = (eventKey) =>
    http.get(`/api/cp/event/${eventKey}/module/auth/external`)
        .then(onSuccess, onFail);
